import buildStdDbModelActions from './std-db-model-actions';

export default buildStdDbModelActions('user-licences');
